import { render, staticRenderFns } from "./AccessibilityStatementLayout.vue?vue&type=template&id=9aa7dac8&"
import script from "./AccessibilityStatementLayout.vue?vue&type=script&lang=js&"
export * from "./AccessibilityStatementLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa7dac8')) {
      api.createRecord('9aa7dac8', component.options)
    } else {
      api.reload('9aa7dac8', component.options)
    }
    module.hot.accept("./AccessibilityStatementLayout.vue?vue&type=template&id=9aa7dac8&", function () {
      api.rerender('9aa7dac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/AccessibilityStatementLayout.vue"
export default component.exports